import getApiClient from '../../../shared/api/api-client/getApiClient';
import ApiResultStatus from '../../../shared/api/api-result/ApiResultStatus';

const FORBIDDEN_HTTP_CODE = 403;

export async function getCanCreateUsers(adminId: string): Promise<
  | {
      canCreateUsers: boolean;
      status: ApiResultStatus.OK;
    }
  | {
      errorMessage: string;
      status: ApiResultStatus.ACCESS_DENIED;
    }
  | {
      errorMessage: string;
      status: ApiResultStatus.ERROR;
    }
> {
  const client = getApiClient();

  const response = await client.get(`/api/user/${adminId}/can_create_users`);

  if (!response.ok && response.status === FORBIDDEN_HTTP_CODE) {
    return {
      errorMessage: await response.errorMessage(),
      status: ApiResultStatus.ACCESS_DENIED,
    };
  }

  if (!response.ok) {
    return {
      errorMessage: await response.errorMessage(),
      status: ApiResultStatus.ERROR,
    };
  }

  const json = await response.json<{
    canCreateUsers: boolean;
  }>();

  return {
    canCreateUsers: json.canCreateUsers,
    status: ApiResultStatus.OK,
  };
}
